// btw-front/src/components/charts/MiniDonut.jsx
import React from "react";

/**
 * conic-gradient 기반 도넛.
 *  data: [{ label, value, color }, ...]
 */
export function MiniDonut({ data = [], size = 140, total, centerLabel, className = "" }) {
  const sum = total ?? data.reduce((a, d) => a + (d.value || 0), 0);
  let cursor = 0;
  const stops = [];
  if (sum > 0) {
    data.forEach((d, i) => {
      const start = cursor;
      const end = cursor + ((d.value || 0) / sum) * 100;
      stops.push(`${d.color || "#cbd5e1"} ${start}% ${end}%`);
      cursor = end;
    });
  } else {
    stops.push("#e2e8f0 0% 100%"); // empty 상태 라이트 그레이
  }
  const bg = `conic-gradient(${stops.join(", ")})`;

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <div
        className="relative shrink-0 rounded-full"
        style={{ width: size, height: size, background: bg }}
        role="img"
        aria-label="Donut chart"
      >
        <div
          className="absolute inset-0 m-auto flex flex-col items-center justify-center rounded-full bg-white text-center"
          style={{ width: size * 0.62, height: size * 0.62 }}
        >
          <div className="text-xl font-bold tabular-nums text-slate-900">{sum}</div>
          {centerLabel && <div className="text-[10px] text-slate-500">{centerLabel}</div>}
        </div>
      </div>
      <ul className="grid gap-1.5 text-xs">
        {data.map((d, i) => (
          <li key={i} className="flex items-center gap-2">
            <span
              aria-hidden="true"
              className="inline-block h-2.5 w-2.5 rounded-sm"
              style={{ background: d.color || "#cbd5e1" }}
            />
            <span className="text-slate-700">{d.label}</span>
            <span className="ml-auto tabular-nums text-slate-500">{d.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
